import React, {PropTypes} from "react";
import {connect} from "react-redux";
import RosterTable from "./RosterTable";
import SearchForm from "./SearchForm";
import Dates from "../../../classes/dates";
import axios from "axios";
import toastr from "toastr";
import moment from "moment";
let dateObject = new Dates();
class AttendanceRoster extends React.Component {

  constructor() {
    super();
    this.state = {date: {startDate: null, endDate: null}, indirect: false, newRoster: false, previous: false};
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.changeIndirect = this.changeIndirect.bind(this);
    this.submitFirstTime = this.submitFirstTime.bind(this);
    this.getRoster = this.getRoster.bind(this);
    this.refresh = this.refresh.bind(this);
    this.changeDates = this.changeDates.bind(this);
    this.usePrevious = this.usePrevious.bind(this);
  }

  next() {
    let x = this.state.date.startDate;
    x.setDate(x.getDate() + 7);
    let y = this.state.date.endDate;
    y.setDate(y.getDate() + 7);
    this.getRoster(x, y, this.state.indirect);
  }

  previous() {
    let x = this.state.date.startDate;
    x.setDate(x.getDate() - 7);
    let y = this.state.date.endDate;
    y.setDate(y.getDate() - 7);

    this.getRoster(x, y, this.state.indirect);
  }

  changeDates(event, dates) {
    console.log(dates);
    let startDate = moment(dates);
    let endDate = moment(startDate);
    console.log(startDate.format());
    endDate.add(6, 'days');

    this.getRoster(new Date(startDate), new Date(endDate), this.state.indirect);

  }

  usePrevious() {
    let x = new Date(this.state.date.startDate);
    x.setDate(x.getDate() - 7);
    let y = new Date(this.state.date.endDate);
    y.setDate(y.getDate() - 7);
    let teamRosterCurrent = this.state.teamRoster;
    let count = new Object();
    let summary = new Object();
    axios.get(process.env.REQ_URL + "/attendance/team/getRoster?q=" + JSON.stringify({
        startDate: moment(x).format(),
        endDate: moment(y).format(),
        indirect: this.state.indirect
      }),
      {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let teamRoster = response.data.data;

      let dateRange = dateObject.getDates(x, y);
      let newRoster = false;
      dateRange.map((column)=> {
        count[moment(column).add(7, 'days').format('YYYY-MM-DD')] = new Object();
        count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['W'] = 0;
        count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['N'] = 0;
        count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['L'] = 0;

      });
      teamRoster = teamRoster.map((node, idX)=> {
        let rosterEmployee = new Object();
        rosterEmployee.empId = node.empId;
        rosterEmployee.name = node.name;


        dateRange.map((column)=> {
          switch (node.roster[moment(column).format('YYYY-MM-DD')]) {
            case 'W':
              count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['W']++
              break;
            case 'N':
              count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['N']++;
              break;
            default:
              count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['L']++;

          }

          if (teamRosterCurrent[idX][moment(column).add(7, 'days').format('YYYY-MM-DD')] == 'L')
            rosterEmployee[moment(column).add(7, 'days').format('YYYY-MM-DD')] = 'L';
          else if (teamRosterCurrent[idX][moment(column).add(7, 'days').format('YYYY-MM-DD')] == 'P')
            rosterEmployee[moment(column).add(7, 'days').format('YYYY-MM-DD')] = 'P';
          else {
            if (node.roster[moment(column).format('YYYY-MM-DD')] == 'N')
              rosterEmployee[moment(column).add(7, 'days').format('YYYY-MM-DD')] = 'N';
            else
              rosterEmployee[moment(column).add(7, 'days').format('YYYY-MM-DD')] = 'W';
          }
        });


        return rosterEmployee;
      });
      summary.name = "Summary"
      dateRange.map((column)=> {

        summary[moment(column).add(7, 'days').format('YYYY-MM-DD')] = "W:" + count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['W'] + " NW:" + count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['N'] + " L:" + count[moment(column).add(7, 'days').format('YYYY-MM-DD')]['L'];

      });
      console.log(teamRoster);
      this.setState({teamRoster: teamRoster, newRoster: newRoster, previous: true, summary: summary});

    }).catch((error)=> {
      console.log(error);
      toastr.error("Error Occured")
    });


  }

  changeIndirect() {
    this.getRoster(this.state.date.startDate, this.state.date.endDate, !this.state.indirect);

  }

  submitFirstTime(requestObject) {

    axios.post(process.env.REQ_URL + "/attendance/team/uploadRoster", {data: requestObject}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((reponse)=> {
      this.getRoster(this.state.date.startDate, this.state.date.endDate, this.state.indirect);
    }).catch((error)=> {
      toastr.error("Error Occurred");

    })
  }

  getRoster(startDate, endDate, indirect) {
    console.log(startDate);

    axios.get(process.env.REQ_URL + "/attendance/team/getRoster?q=" + JSON.stringify({
        startDate: moment(startDate).format(),
        endDate: moment(endDate).format(),
        indirect: indirect
      }),
      {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let teamRoster = response.data.data;
      console.log(startDate);
      let count = new Object();
      let dateRange = dateObject.getDates(startDate, endDate);
      dateRange.map((column)=> {
        count[moment(column).format('YYYY-MM-DD')] = new Object();
        count[moment(column).format('YYYY-MM-DD')]['W'] = 0;
        count[moment(column).format('YYYY-MM-DD')]['N'] = 0;
        count[moment(column).format('YYYY-MM-DD')]['L'] = 0;

      });


      let newRoster = false;
      teamRoster = teamRoster.map((node)=> {
        let rosterEmployee = new Object();
        rosterEmployee.empId = node.empId;
        rosterEmployee.name = node.name;
        dateRange.map((column)=> {
          rosterEmployee[moment(column).format('YYYY-MM-DD')] = node.roster[moment(column).format('YYYY-MM-DD')];
          switch (node.roster[moment(column).format('YYYY-MM-DD')]) {
            case 'W':
              count[moment(column).format('YYYY-MM-DD')]['W']++;
              break;
            case 'N':
              count[moment(column).format('YYYY-MM-DD')]['N']++;
              break;
            default:
              count[moment(column).format('YYYY-MM-DD')]['L']++;

          }
          rosterEmployee[moment(column).format('YYYY-MM-DD')] = node.roster[moment(column).format('YYYY-MM-DD')];

        });


        return rosterEmployee;
      });
      let summary = new Object();

      summary.name = "Summary"
      dateRange.map((column)=> {

        summary[moment(column).format('YYYY-MM-DD')] = "W:" + count[moment(column).format('YYYY-MM-DD')]['W'] + " NW:" + count[moment(column).format('YYYY-MM-DD')]['N'] + " L:" + count[moment(column).format('YYYY-MM-DD')]['L'];

      });
      console.log(summary);


      this.setState({
        date: {startDate: startDate, endDate: endDate},
        teamRoster: teamRoster,
        newRoster: newRoster,
        previous: false,
        summary: summary,
        indirect: indirect
      });
    }).catch((error)=> {
      console.log(error);
      toastr.error("Error Occured")
    });


  }

  refresh() {

    let startDate = dateObject.getMondayToSunday().startDate;
    let endDate = dateObject.getMondayToSunday().endDate;
    this.getRoster(this.state.date.startDate, this.state.date.endDate, this.state.indirect);
  }

  componentDidMount() {

    let startDate = dateObject.getMondayToSunday().startDate;
    let endDate = dateObject.getMondayToSunday().endDate;
    this.getRoster(startDate, endDate, this.state.indirect);


  }

  render() {
    console.log("HOME STATE");
    console.log(this.state);

    return ( <div>
        <div>
          <div role="tabpanel" className="tab-pane" id="apply">
            <div className="row clearfix">
              <div className="inner-col-wrap inner-table-wrap ">
                <div className="col-md-12" style={{margin: 0, padding: 0}}>
                  <div className="col-md-12">
                    <SearchForm
                      dates={this.state.date}
                      indirect={this.state.indirect}
                      changeIndirect={this.changeIndirect}
                      next={this.next}
                      previous={this.previous}
                      changeDates={this.changeDates}
                    /></div>

                  <div className="col-md-12">
                    <hr/>
                  </div>


                  <div className="col-md-12">
                    <RosterTable
                      submit={this.submitFirstTime}
                      teamRoster={this.state.teamRoster}
                      newRoster={this.state.newRoster}
                      dates={this.state.date}
                      refresh={this.refresh}
                      changeDates={this.changeDates}
                      usePrevious={this.usePrevious}
                      previous={this.state.previous}
                      summary={this.state.summary}

                    /></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

AttendanceRoster.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state
  };

}


export default connect(mapStateToProps)(AttendanceRoster);




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/AttendanceRoster/AttendanceRoster.js
 **/